import {ApiMode, ConfigService, SearchConfig, SystemConfig, VaultProfileConfig} from "@shared-library";
import {NGXLogger} from "ngx-logger";

export type OAuthCallbackContext = {
  codeVerifier: string;
  systemConfig: SystemConfig;
  vaultProfileConfig?: Partial<VaultProfileConfig>;
  searchConfig?: Partial<SearchConfig>;
};

export const FASTEN_CONNECT_OAUTH_CONTEXT_CACHE_KEY_PREFIX = 'fasten_connect_oauth_context:';


export function getOAuthCallbackContext(state: string, logger?: NGXLogger): OAuthCallbackContext {
  const storedContext = localStorage.getItem(`${FASTEN_CONNECT_OAUTH_CONTEXT_CACHE_KEY_PREFIX}${state}`);
  if (storedContext) {
    try {
      const parsedContext = JSON.parse(storedContext);
      if (parsedContext.codeVerifier && parsedContext.systemConfig?.publicId) {
        const systemConfig = {
          ...parsedContext.systemConfig,
          apiMode: parsedContext.systemConfig.apiMode || getApiModeFromPublicId(parsedContext.systemConfig.publicId),
        };
        return {
          codeVerifier: parsedContext.codeVerifier,
          systemConfig,
          vaultProfileConfig: parsedContext.vaultProfileConfig,
          searchConfig: parsedContext.searchConfig,
        };
      }
    } catch (err) {
      logger?.warn('Failed to parse OAuth callback context', err);
    }
  }
  return {} as OAuthCallbackContext;
}

export function restoreConfigurationFromOauthContext(oauthContext: OAuthCallbackContext, configService: ConfigService): void {
  configService.systemConfig = oauthContext.systemConfig;
  if (oauthContext.vaultProfileConfig) {
    configService.vaultProfileConfig = oauthContext.vaultProfileConfig;
  }
  if (oauthContext.searchConfig) {
    configService.searchConfig = oauthContext.searchConfig;
  }
}

function getApiModeFromPublicId(publicId: string): ApiMode {
  const publicIdParts = publicId.split('_');
  if (publicIdParts.length === 3 && publicIdParts[1] === ApiMode.Live) {
    return ApiMode.Live;
  }

  return ApiMode.Test;
}
